import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getWhatsAppContext } from "@/lib/whatsappContext";

const PHONE = "447909970556";

// Public storefront pages only — no checkout, no B2B/manager areas
const SHOW_ON = [
  "/", "/shop", "/drumsticks", "/custom-drumsticks", "/live-shop",
  "/merch", "/contact", "/artists", "/account", "/customer",
];

const shouldShow = (pathname) =>
  SHOW_ON.some((p) => (p === "/" ? pathname === "/" : pathname === p || pathname.startsWith(p + "/")));

export const WhatsAppBubble = () => {
  const { pathname } = useLocation();
  const [context, setContext] = useState(getWhatsAppContext());

  useEffect(() => {
    const sync = () => setContext(getWhatsAppContext());
    window.addEventListener("whatsapp-context-change", sync);
    return () => window.removeEventListener("whatsapp-context-change", sync);
  }, []);

  if (!shouldShow(pathname)) return null;

  const message = context
    ? `Hi Temple of Sound! I'm interested in the ${context}.`
    : "Hi Temple of Sound!";
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-bubble"
      className="group fixed bottom-20 md:bottom-6 right-4 md:right-6 z-40 flex items-center"
    >
      <span className="hidden md:block max-w-0 overflow-hidden group-hover:max-w-[260px] group-hover:mr-3 transition-all duration-300 whitespace-nowrap bg-[#111111] border border-zinc-700 text-zinc-200 text-xs px-0 group-hover:px-3 py-2 rounded-full" data-testid="whatsapp-bubble-label">
        {context ? `Ask about the ${context}` : "Chat with us on WhatsApp"}
      </span>
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-black/40 hover:scale-105 transition-transform duration-200">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
        <svg viewBox="0 0 32 32" className="w-7 h-7 relative" fill="#fff" aria-hidden="true">
          <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.594 4.466 1.72 6.412L3.2 28.8l6.564-1.686a12.74 12.74 0 0 0 6.24 1.63h.005c7.058 0 12.798-5.74 12.798-12.8 0-3.42-1.33-6.634-3.748-9.05a12.72 12.72 0 0 0-9.055-3.694zm0 23.418h-.004a10.6 10.6 0 0 1-5.406-1.48l-.388-.23-3.895 1 1.04-3.797-.253-.39a10.577 10.577 0 0 1-1.626-5.66c0-5.868 4.775-10.643 10.647-10.643 2.844 0 5.516 1.108 7.526 3.12a10.58 10.58 0 0 1 3.115 7.528c0 5.87-4.775 10.644-10.643 10.644zm5.838-7.97c-.32-.16-1.893-.934-2.186-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.351-.498-2.573-1.588-.951-.848-1.593-1.896-1.78-2.216-.187-.32-.02-.493.14-.652.144-.144.32-.373.48-.56.16-.187.213-.32.32-.533.107-.214.054-.4-.026-.56-.08-.16-.72-1.734-.987-2.374-.26-.624-.523-.54-.72-.55l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.093-1.12 2.666s1.146 3.094 1.306 3.307c.16.213 2.256 3.444 5.466 4.83.764.33 1.36.527 1.825.674.767.244 1.465.21 2.017.127.615-.092 1.893-.774 2.16-1.52.267-.747.267-1.387.187-1.52-.08-.134-.293-.214-.613-.374z" />
        </svg>
      </span>
    </a>
  );
};

export default WhatsAppBubble;
